import { Component, OnInit, Input } from '@angular/core';
import { NoteModel } from '@app/shared/models/note.model';

@Component({
  selector: 'app-building-notes-card',
  templateUrl: './building-notes-card.component.html',
  styleUrls: ['./building-notes-card.component.scss']
})
export class BuildingNotesCardComponent implements OnInit {

  @Input() public notes: NoteModel;

  constructor() { }

  ngOnInit() {
  }

}
